<template>
    <div>
        <form method="post" v-on:submit="save">
            <div class="row">
                <div class=" col-lg-12 col-md-12 col-sm-12">
                    <div class="card">
                        <div class="card-header p-2">
                            <ul class="nav nav-pills">
                                <li class="nav-item"><a class="nav-link" href="#activity" data-toggle="tab" v-on:click="tabChange(1)" v-bind:class="activetab == 1 ? ' active': ''">1. Admission Details</a></li>
                                <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="tabChange(2)" v-bind:class="activetab == 2 ? ' active': (st.Tab >= 1 ? '' : 'disabled')">2. Personal Information</a></li>
                                <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="tabChange(3)" v-bind:class="activetab == 3 ? ' active': (st.Tab >= 2 ? '' : 'disabled')">3. Education Background</a></li>
                                <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="tabChange(4)" v-bind:class="activetab == 4 ? ' active': (st.Tab >= 3 ? '' : 'disabled')">4. Documents</a></li>
                                <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="tabChange(5)" v-bind:class="activetab == 5 ? ' active': (st.Tab > 3 ? '' : 'disabled')">Remarks</a></li>
                            </ul>
                        </div>

                        <div class="card-body">
                            <div class="tab-content active" id="custom-tabs-four-tabContent">
                                <div v-if="activetab == 1">
                                    <div class="row">
                                        <div class="col-md-10 col-sm-6">
                                            <div class="row">
                                                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3" v-if="st.IsOnline == 'false' && st.ProspectStudentID == 0">
                                                    <label>
                                                        Form No * <i v-show="showverified" style="color: mediumseagreen">verified</i>
                                                        <i style="color: orangered" v-show="showunverified">invalid</i>
                                                    </label>
                                                    <input type="text" v-bind:disabled="showverified" class="form-control" v-model="st.FormNo" maxlength="35" v-on:change="validateFormNo" autocomplete="off" placeholder="(written on admission form)" required>
                                                </div>

                                                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                                    <label for="validationCustom01">Degree *</label>
                                                    <select style="width: 100%" class="form-control" v-model="st.DegreeID" required v-on:change="degreeChange()">
                                                        <option value="" disabled="disabled" selected="selected">-- Select Degree --</option>
                                                        <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.DegreeName}}</option>
                                                    </select>
                                                </div>

                                                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                                    <label for="validationCustom01">Applicant Name *</label>
                                                    <input type="text" class="form-control" style="text-transform: capitalize" pattern=".{3,}" title="only alphabets allowed" v-model.trim="st.Name" maxlength="50" autocomplete="off" placeholder="Candidate's full name (max 50 characters)" required>
                                                </div>
                                                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                                    <label for="validationCustom02">Applicant Mobile *</label>
                                                    <input type="text" class="form-control" v-mask="'###########'" pattern=".{11,11}" title="11 digit required" maxlength="11" placeholder="03001234567" v-model.trim="st.MobileNo" autocomplete="off" required>
                                                </div>
                                                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                                    <div class="checkbox" style=" margin: 0px;">
                                                        <label style=" padding-left: 0px; font-weight: bold">WhatsApp No *</label>
                                                        <label>
                                                            <input v-on:change="sameChange()" v-model="same" style="margin-top: 0px;" type="checkbox">
                                                            Same as Mobile
                                                        </label>
                                                    </div>
                                                    <input type="text" class="form-control" v-mask="'###########'" pattern=".{11,11}" title="11 digit required" maxlength="11" placeholder="03001234567" v-model.trim="st.WhatsAppNo" autocomplete="off" required>
                                                </div>
                                                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                                    <label for="validationCustom02">CNIC/Form B No *</label>
                                                    <input type="text" class="form-control" v-model.trim="st.CNIC" v-mask="'#############'" pattern=".{13,13}" title="13 digits required" autocomplete="off" placeholder="_____________" maxlength="15" required>
                                                </div>
                                                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                                    <label for="validationCustom02">Date of Birth *</label>
                                                    <input type="date" class="form-control" placeholder="dd-MMM-YYYY" v-model="st.DateOfBirth" autocomplete="off" required>
                                                </div>
                                                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                                    <label for="validationCustom02">Image *</label><br />
                                                    <input type="file" id="fileUpload" v-on:change="onfileupload">
                                                </div>
                                            </div>
                                            <div class="table-responsive" style="margin-top: 8px;" v-if="st.DegreeID != 0 || st.DegreeID != ''">
                                                <table class="table table-sm ">
                                                    <thead class="bg-info">
                                                        <tr>
                                                            <th style="width: 7px;"></th>
                                                            <th style="width: 7px; text-align: left"></th>
                                                            <th style="width: 10%; text-align: center">Priority</th>
                                                            <th>Program *</th>
                                                            <th>Category *</th>
                                                            <th style="width: 100px">Eligible</th>
                                                            <th style="width: 15%">In-Eligible Reason</th>
                                                            <th style="width: 1px" v-if="st.IsOnline == 'true'">Amount</th>
                                                            <th style="width: 1px"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in  choices">
                                                            <td style="width: 1px">
                                                                <button class="hover" v-show="index != 0" v-on:click="moveUp(index)" style="background-color: transparent; border: none" type="button"><i class="fa fa-arrow-up"></i></button>
                                                            </td>
                                                            <td style="width: 1px;">
                                                                <button width="20px" v-show="choices.length - 1 != index" v-on:click="moveDown(index)" style="background-color: transparent; border: none" type="button"><i class="fa fa-arrow-down"></i></button>
                                                            </td>
                                                            <td style="width: 10%; text-align: center">{{index + 1}}</td>
                                                            <td>
                                                                <select class="form-control" v-model="item.ProgramID" v-on:change="programChange(item.ProgramID,index)" required>
                                                                    <option value="0" disabled="disabled" selected="selected">-- Select Program --</option>
                                                                    <option v-for="p in programs" v-bind:value="p.ProgramID">{{p.ProgramName}}</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <select class="form-control" v-model="item.CategoryID" v-on:change="programChange(item.ProgramID,index)" required>
                                                                    <option value="0" disabled="disabled" selected="selected">-- Select Category --</option>
                                                                    <option v-for="item in categories" v-bind:value="item.AdmissionCategoryID">{{item.Name}}</option>
                                                                </select>
                                                                <div v-if="item.CategoryID != 0 && categories.find( x => x.AdmissionCategoryID == item.CategoryID).Description" class="callout callout-info" style="border-left: 5px solid #117a8b; border-right: 5px solid #117a8b; padding: 2px; margin-top: 4px; ">
                                                                    <small>{{item.CategoryID != 0 ? categories.find( x => x.AdmissionCategoryID == item.CategoryID).Description : ''}}</small>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <select class="form-control" v-model="item.Eligible">
                                                                    <option value="true">E</option>
                                                                    <option value="false">N/E</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <select v-bind:disabled="item.Eligible == 'true' || item.Eligible == true" class="form-control" v-model="item.ReasonID" required>
                                                                    <option value="">--Select Reason--</option>
                                                                    <option v-bind:value="item.InEligibleReasonID" v-for="item in reasons">{{item.Text}}</option>

                                                                </select>
                                                            </td>
                                                            <td style="width: 1px" v-if="st.IsOnline == 'true'">{{getFee(index)}}</td>
                                                            <td style="width: 1px">
                                                                <button type="button" style="background-color: transparent; border: none" v-on:click="removeProgram(index)"><i class="fa fa-trash fa-2x"></i></button>
                                                            </td>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td align="center" colspan="7">
                                                                <button class="btn btn-default btn-sm" v-if="choices.length < allowedchoices" style="width: 100%" type="button" v-on:click="addProgram()">Apply in another program</button>
                                                                <label v-if="choices.length >= allowedchoices">You cannot apply in more than <b>{{allowedchoices}}</b> Programs</label>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>

                                        </div>
                                        <div class="col-md-2 col-sm-4 col-xga-6">
                                            <img v-bind:src="image" class="img-thumbnail" />
                                            <button type="button" style="width: 100%" v-on:click="removePic()" class="btn btn-sm btn-default">Remove</button>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="activetab == 2">
                                    <div class="row">
                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom01">Applicant Name *</label>
                                            <input type="text" class="form-control" id="validationCustom01" v-model.trim="st.Name" pattern=".{3,}" onKeyPress="return allowAlphabet(event)" title="only alphabets allowed min length is 3" maxlength="50" autocomplete="off" placeholder="Candidate's full name (max 50 characters)" required>
                                        </div>
                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom01">Gender *</label>
                                            <select style="width: 100%" class="form-control" id="ddlGender" v-model="st.GenderID" required>
                                                <option value="" disabled="disabled" selected="selected">-- Select Gender --</option>
                                                <option v-for="item in genders" v-bind:value="item.GenderID">{{item.Name}}</option>
                                            </select>
                                        </div>

                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom02">Father Name *</label>
                                            <input type="text" class="form-control" v-model.trim="st.FathersName" onKeyPress="return allowAlphabet(event)" pattern=".{3,}" title="only alphabet allowed min length is 3" autocomplete="off" maxlength="50" placeholder="Candidate's father name (max 50 characters)" required>
                                        </div>


                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom01">Father CNIC</label>
                                            <input type="text" class="form-control" v-model.trim="st.FatherCNIC" v-mask="'#####-#######-#'" title="13 digit required" autocomplete="off" placeholder="_____________">
                                        </div>

                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom01">Father/ Guardian Mobile </label>
                                            <input type="text" class="form-control" v-model.trim="st.FatherMobileNo" v-mask="'###########'" maxlength="11" title="11 digit required" autocomplete="off" placeholder="_____________" />
                                        </div>



                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom01">Domicile *</label>
                                            <select style="width: 100%" class="form-control" v-model="st.DomicileID" required>
                                                <option value="" disabled="disabled" selected="selected">-- Select Domicile --</option>
                                                <option v-for="item in cities" v-bind:value="item.CityID">{{item.Name}}</option>
                                            </select>
                                        </div>
                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom01">City/ Village *</label>
                                            <select style="width: 100%" class="form-control" v-model="st.CityID" required>
                                                <option value="" disabled="disabled" selected="selected">-- Select City --</option>
                                                <option v-for="item in cities" v-bind:value="item.CityID">{{item.Name}}</option>
                                            </select>
                                        </div>

                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3" v-if="st.CityID == 281">
                                            <label for="validationCustom01">City/ Village Name *</label>
                                            <input style="width: 100%" class="form-control" v-model="st.OtherCity" required />
                                        </div>
                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom01">District *</label>
                                            <input style="width: 100%" class="form-control" v-model="st.District" required />
                                        </div>
                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom01">Tehsil *</label>
                                            <input style="width: 100%" class="form-control" v-model="st.Tehsil" required />
                                        </div>
                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom02">Permanent Address *</label>
                                            <input type="text" class="form-control " maxlength="150" v-model.trim="st.Address" placeholder="House #: 00, Street #: 00, Area Name (max 150 characters)" autocomplete="off" required>
                                        </div>

                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom02">Postal Address *</label>
                                            <input type="text" class="form-control" maxlength="150" v-model.trim="st.PostalAddress" placeholder="(max 150 characters)" autocomplete="off" required>
                                        </div>

                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom02">Postal Code *</label>
                                            <input type="text" class="form-control" maxlength="150" v-model.trim="st.PostalCode" v-mask="'#####'" placeholder="(max 5 numbers)" autocomplete="off" required>
                                        </div>

                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom02">Applicant Mobile *</label>
                                            <input type="text" class="form-control" v-mask="'###########'" title="11 digit required" maxlength="11" placeholder="03001234567" v-model.trim="st.MobileNo" autocomplete="off" required>
                                        </div>

                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom02">Land Line (along with area code)</label>
                                            <input type="text" class="form-control" maxlength="11" v-mask="'###-########'" placeholder="04230000000" v-model.trim="st.LandLineNo" autocomplete="off">
                                        </div>

                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom02">Email </label>
                                            <input type="email" class="form-control" placeholder="Candidate's email address" v-model.trim="st.Email" maxlength="50" autocomplete="off">
                                        </div>

                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom02">Religion</label>
                                            <select style="width: 100%" class="form-control" v-model="st.ReligionID">
                                                <option value="" disabled="disabled" selected="selected">-- Select Religion --</option>
                                                <option v-for="item in religions" v-bind:value="item.ReligionID">{{item.Name}}</option>
                                            </select>
                                        </div>

                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom02">Blood Group</label>
                                            <select style="width: 100%" class="form-control" v-model="st.BloodGroup">
                                                <option value="" disabled="disabled" selected="selected">-- Select Blood Group --</option>
                                                <option value="A+">A+</option>
                                                <option value="A-">A-</option>
                                                <option value="B+">B+</option>
                                                <option value="B-">B-</option>
                                                <option value="O+">O+</option>
                                                <option value="O-">O-</option>
                                                <option value="AB+">AB+</option>
                                                <option value="AB-">AB-</option>
                                            </select>
                                        </div>
                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom01">Disability</label>
                                            <select style="width: 100%" class="form-control" v-model="st.Disability">
                                                <option value="false" selected>No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </div>
                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3" v-if="st.Disability == true" v-on:change="disabilityChange()">
                                            <label for="validationCustom01">Disability Type*</label>
                                            <input maxlength="150" style="width: 100%" class="form-control" v-model="st.DisabilityType" required />
                                        </div>
                                        <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                                            <label for="validationCustom01">Hostel Required</label>
                                            <select style="width: 100%" class="form-control" v-model="st.HostelRequired">
                                                <option value="false" selected>No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="activetab == 3">
                                    <div class="table-responsive">
                                        <table class="table table-sm table-color" style="font-size: 10px; width: 100%">
                                            <thead class="bg-info">
                                                <tr>
                                                    <th style="width: 130px">Education Level</th>
                                                    <th style="width: 100px">Type</th>
                                                    <th>Degree</th>
                                                    <th>Year/ Date</th>
                                                    <th style="width: 90px">Roll No</th>
                                                    <th>Board/Institute</th>
                                                    <th style="width: 79px">Tot. Marks</th>
                                                    <th style="width: 79px">Obt. Marks</th>
                                                    <th>%</th>
                                                    <th style="width: 79px">Grade</th>
                                                    <th style="width: 12%">Major Subject</th>
                                                    <th style="width: 120px; text-align: center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in education" v-bind:style="getEducationStyle(item.Percentage)">
                                                    <td v-if="item.Required">
                                                        {{item.EducationLevelName}} <span v-if="item.Optional">(Optional)</span>
                                                        <i class="fa fa-question" data-toggle="tooltip" v-bind:title="item.MacAddress"></i>
                                                    </td>

                                                    <td v-if="!item.Required" style="text-align: center; vertical-align: middle">
                                                        <select class="form-control" required v-model="item.EducationLevelID">
                                                            <option value="" disabled="disabled" selected="selected">-Select-</option>
                                                            <option v-for="ed in alleducations" v-bind:value="ed.EducationLevelID">{{ed.EducationLevelName}}</option>
                                                        </select>
                                                    </td>

                                                    <td style="text-align: center; vertical-align: middle">
                                                        <select class="form-control" v-bind:required="!item.Optional" v-model="item.Type" v-bind:disabled="item.EducationLevelID < 3" v-if="item.EducationLevelID < 12">
                                                            <option value="Annual">Annual</option>
                                                            <option value="Semester" v-if="item.EducationLevelID > 2">Semester</option>
                                                        </select>

                                                        <span v-else>--</span>

                                                    </td>
                                                    <td style="text-align: center; vertical-align: middle">
                                                        <input class="form-control" v-if="item.EducationLevelID < 12" placeholder="Degree Title" pattern=".{3,}" maxlength="40" style="height: 32px !important" v-bind:required="!item.Optional" v-model.trim="item.DegreeName" />
                                                        <span v-else>--</span>
                                                    </td>
                                                    <td style="text-align: center; vertical-align: middle">
                                                        <input class="form-control" v-if="item.EducationLevelID < 12" v-on:change="passingYearChange(index)" onkeypress="return allowOnlyNumber(event);" maxlength="4" v-bind:required="!item.Optional" v-model.trim="item.PassingYear" />
                                                        <input v-else class="form-control" type="date" style="height: 32px !important" v-bind:required="!item.Optional" v-model="item.TestDate" />

                                                    </td>
                                                    <td style="text-align: center; vertical-align: middle">
                                                        <input class="form-control number" maxlength="15" style="height: 32px !important" v-bind:required="!item.Optional" v-model.trim="item.RollNo" />
                                                    </td>
                                                    <td style="text-align: center; vertical-align: middle">
                                                        <input class="form-control" maxlength="40" v-if="item.EducationLevelID < 12" placeholder="Lahore Board" pattern=".{3,}" style="height: 32px !important" v-bind:required="!item.Optional" v-model.trim="item.InstituteName" />
                                                        <span v-else>--</span>
                                                    </td>
                                                    <td style="text-align: center; vertical-align: middle">
                                                        <input class="form-control" style="height: 32px !important" v-bind:required="!item.Optional" v-bind:disabled="!item.ResultAwaiting ? false : true" onkeypress="return allowOnlyNumberandPeriod(event);" maxlength="4" placeholder="1100" v-model="item.TotalMarks" v-on:change="marksChange(item)" />
                                                    </td>
                                                    <td style="text-align: center; vertical-align: middle">
                                                        <input class="form-control" style="height: 32px !important" v-bind:required="!item.Optional" v-bind:disabled="!item.ResultAwaiting ? false : true" onkeypress="return allowOnlyNumberandPeriod(event);" maxlength="4" placeholder="900" v-model="item.ObtainedMarks" v-on:change="marksChange(item)" />
                                                    </td>
                                                    <td style="text-align: center; vertical-align: middle">
                                                        {{Number(item.Percentage).toFixed(3)}}
                                                    </td>
                                                    <td style="text-align: center; vertical-align: middle">
                                                        <select v-if="item.EducationLevelID < 12" class="form-control" v-bind:required="!item.Optional" v-bind:disabled="!item.ResultAwaiting ? false : true" v-model="item.Division">
                                                            <option value="">-Select-</option>
                                                            <option value="A+">A+</option>
                                                            <option value="A">A</option>
                                                            <option value="B+">B+</option>
                                                            <option value="B">B</option>
                                                            <option value="C+">C+</option>
                                                            <option value="C">C</option>
                                                            <option value="D">D+</option>
                                                            <option value="D">D</option>
                                                        </select>
                                                        <span v-else>--</span>
                                                    </td>
                                                    <td style="text-align: center; vertical-align: middle">
                                                        <input v-if="item.EducationLevelID < 12" class="form-control" name="major" v-model="item.MajorSubjects" style="height: 32px !important" placeholder="Major Subject" />
                                                        <span v-else>--</span>
                                                    </td>
                                                    <td style="text-align: left; vertical-align: middle">

                                                        <div class="checkbox" v-if="item.AllowResultAwaiting">
                                                            <label>
                                                                <input type="checkbox" style="margin-top: 0px" v-bind:value="item.Awaiting" v-model="item.ResultAwaiting" v-on:change="resultAwaitingChange(index)">
                                                                Result Await.
                                                            </label>
                                                        </div>

                                                        <div class="checkbox" v-if="item.Percentage > 0">
                                                            <label>
                                                                <input type="checkbox" style="margin-top: 0px" v-model="item.Approved">
                                                                Approved
                                                            </label>
                                                        </div>

                                                        <i class="fa fa-trash" v-if="!item.Required" style="cursor: pointer; align-self: center" v-on:click="removeEducation(index)"></i>

                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colspan="12">
                                                        <button type="button" v-on:click="addEducation()" class="btn btn-sm btn-block btn-default">Add More </button>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                <div v-if="activetab == 4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <table class="table table-borderless">
                                                <thead class="bg-info">
                                                    <tr>
                                                        <th>Document</th>
                                                        <th style="width: 50%">Upload File </th>
                                                        <th style="width: 10%; text-align: center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, ind) in documents">
                                                        <td>
                                                            {{item.DocumentName}} <span v-if="item.Optional">(Optional)</span><br />
                                                            <small>{{item.Description}}</small>
                                                        </td>
                                                        <td>
                                                            <input v-bind:id="'Att' + ind" type="file" v-bind:required="item.Required && item.Attachment == '' ? true: false" v-on:change="documentUpload(ind)" class="form-control" />
                                                            <small v-if="item.Attachment == ''">'Image' and 'PDF' file allowed, Max file size 200 kb</small>
                                                            <small v-else>File Uploaded</small>
                                                        </td>
                                                        <td style="text-align: center;">
                                                            <div v-if="item.Attachment != ''">
                                                                <a href="#" v-on:click="removeDocument(ind)"><i style="color: black" class="fa fa-2x fa-trash"></i></a>
                                                                <a href="#" v-on:click="viewFile(item.Attachment, item.Format)" v-if="item.Format == '.pdf'"><i style="color: black" class="fa fa-2x fa-file-pdf-o"></i></a>
                                                                <a href="#" v-on:click="viewFile(item.Attachment, item.Format)" v-else><i style="color: black" class="fa fa-2x fa-image"></i></a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="documents.length == 0">
                                                        <td colspan="3" class="text-center">No documents are required for admission</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="activetab == 5">
                                    <div class="row">
                                        <div class="col-md-12" v-if="challan.length > 0">
                                            <table class="table table-bordered table-color table-sm">
                                                <thead class="bg-info">
                                                    <tr>
                                                        <th>Mode of Payment</th>
                                                        <th>Date</th>
                                                        <th>Branch Name</th>
                                                        <th>Transaction No.</th>
                                                        <th>Attachment</th>
                                                    </tr>
                                                </thead>
                                                <tr v-for="item in challan">
                                                    <td>{{item.ModeOfPayment}}</td>
                                                    <td>{{item.DepositDate}}</td>
                                                    <td>{{item.Branch}}</td>
                                                    <td>{{item.TransactionNo}}</td>
                                                    <td><a v-if="item.Attachment != ''" href="#" v-on:click="viewFile(item.Attachment, '.png')"><i style="color: black" class="fa fa-2x fa-image"></i></a></td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="col-md-2">
                                            Payment Verified
                                            <select class="form-control" v-model="st.PaymentReceived">
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </select>
                                        </div>
                                        <div class="col-md-2">
                                            Document Verified
                                            <select class="form-control" v-model="st.Verified">
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </select>
                                        </div>
                                        <div class="col-md-8">
                                            Remarks
                                            <input class="form-control" v-model="st.Remarks" maxlength="150" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-md-9">
                                    <button type="button" class="btn btn-danger pull-left" id="Button1" v-on:click="backToRecord()">Back To Record</button>
                                </div>

                                <div class="col-md-3 ">
                                    <div class="btn-group float-right">
                                        <button type="button" class="btn btn-primary " v-if="activetab > 1" style="margin-right: 8px" v-on:click="back()">Back</button>
                                        <button type="submit" v-if="activetab < 7" class="btn btn-success " id="Button2" value="Save&Next">Save & Next</button>
                                        <button type="submit" v-if="activetab == 7" class="btn btn-success ">Save & Close</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
                <!-- /.col -->
            </div>
        </form>

        <div class="modal fade" id="myModal" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header bg-info">
                        <h3 style="color: white" class="modal-title">Confirmation</h3>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 col-lg-12 ">
                                <h2 for="validationCustom01">
                                    Dear Applicant,
                                    <br />
                                    Have you purchased Prospectus/Admission Form?
                                </h2>
                                <div class="form-group">
                                    <div class="radio pull-right">
                                        <label>
                                            <input style="margin-top: 1px;" type="radio" id="customRadioInline1" name="customRadioInline1" value="false" v-model="st.IsOnline">
                                            Yes
                                        </label>
                                        <label>
                                            <input style="margin-top: 1px;" type="radio" id="customRadioInline2" name="customRadioInline1" value="true" v-model="st.IsOnline">
                                            No
                                        </label>
                                    </div>

                                </div>
                                <br />
                                <br />
                                <i class="fa fa-hand-o-right  " style="margin-right: 2px;"></i>If <b>'Yes'</b> then enter Form # (written on Admission Form) and CNIC number provided when you purchased prospectus.
                                <br />
                                <br />
                                <i class="fa fa-hand-o-right " style="margin-right: 2px;"></i>If <b>'No'</b> then you have to pay Admission Fee through system generated challan.
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" type="button" v-on:click="btnContinue()">Continue</button>

                        <a href="../Admission/ProspectStudents" class="btn btn-primary " id="btnSubmit">Back</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>function allowAlphabet(evt) {
        var charCode = (evt.which) ? evt.which : event.keyCode
        if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || charCode == 32)
            return true;
        return false;
    }

    const axios = require('axios').default;

    export default ({
        data() {
            return {
                alt: '',
                activetab: 1,
                errors: [],
                religions: [],
                nationalities: [],
                genders: [],
                countries: [],
                categories: [],
                degrees: [],
                cities: [],
                cnic: '',
                programs: [],
                minage: 0,
                maxage: 0,
                domiciles: [],
                isvalidate: true,
                showverified: false,
                showunverified: false,
                image: '../Images/icon-profile.png',
                activesemester: '',
                isupdate: false,
                allowedchoices: '',
                isconfirmed: false,
                st: {
                    ProspectStudentID: 0,
                    FormNo: '0',
                    //Name: '',
                    GenderID: 0,
                    Tehsil: '',
                    CNIC: '',
                    DegreeID: '',
                    FathersName: '',
                    FatherCNIC: '',
                    FatherMobileNo: '',
                    HostelRequired: false,
                    CityID: 0,
                    CountryID: 1,
                    Hafiz: 'false',
                    Disability: 'false',
                    DisabilityType: null,
                    NationalityID: 1,
                    ReligionID: 0,
                    MobileNo: '',
                    ReligionName: '',
                    LandLineNo: '',
                    Address: '',
                    PostalAddress: '',
                    PostalCode: '',
                    DateOfBirth: '',
                    DomicileID: 0,
                    WhatsAppNo: '',
                    //Email: '',
                    BloodGroup: '',
                    IsOnline: 'true',
                    Remarks: '',
                    RelativeRelation: '',
                    RelativeMobileNo: '',
                    RelativeName: ''
                }, alleducations: [],
                education: [],
                choices: [],
                amount: { FirstAdmissionFee: 0, SecondAdmissionFee: 0 },
                nats: [],
                reasons: [],
                documents: [],
                challan: [],
                same: false,
                countRegional: 0
            }
        },
        created: function () {
            //const urlParams = new URLSearchParams(window.location.search);
            //if (urlParams) {
            //  this.id = Number(urlParams.get('id'));

            //  var uri = window.location.toString();
            //  if (uri.indexOf("?") > 0) {
            //    var clean_uri = uri.substring(0, uri.indexOf("?"));
            //    window.history.replaceState({}, document.title, clean_uri);
            //  }
            //}
        },
        mounted: function () {
            this.pageLoad();
        },
        methods: {

            sameChange() {
                if (this.same)
                    this.st.WhatsAppNo = this.st.MobileNo;
                else
                    this.st.WhatsAppNo = '';
            },

            viewFile(src, format) {
                if (format == '.pdf') {
                    var pdfString = src.split(',')[1];
                    console.log(pdfString);
                    let pdfWindow = window.open("")
                    pdfWindow.document.write(
                        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                        encodeURI(pdfString) + "'></iframe>"
                    );
                }
                else {
                    var newTab = window.open();
                    newTab.document.body.innerHTML = '<img src="' + src + '" >';
                }
            },

            tabChange(t) {
                if (this.st.Tab + 1 >= t || t == 5 || t == 1) {
                    var vm = this;
                    this.activetab = t;
                    if (this.activetab == 4) {
                        startReq();
                        axios.post('/api/AdmissionApi/loadDocuments?id=' + vm.st.ProspectStudentID + '&degreeID=' + vm.st.DegreeID)
                            .then(function (d) {
                                endReq();
                                vm.documents = d.data;
                            })
                            .catch(function (error) {
                                console.log(error);
                            })
                    }
                }
            },

            addEducation() {
                this.education.push({ EducationLevelID: '', DegreeName: '', PassingYear: '', RollNo: '', InstituteName: '', TotalMarks: '', ObtainedMarks: '', Division: '', MajorSubjects: '', ResultAwaiting: false, Required: false, Type: 'Annual' });
            },

            getEducationStyle(per) {
                if (per < 50) {
                    return "background-color: lightgoldenrodyellow";
                }
            },

            degreeChange: function () {
                var vm = this;
                axios.post('/api/AdmissionApi/degreeChange?ID=' + vm.st.DegreeID)
                    .then(function (de) {

                        vm.programs = de.data["pro"];

                        if (de.data["edu"].length > 0) {
                            vm.education = de.data["edu"];
                            vm.alleducations = de.data["alledu"];
                            vm.allowedchoices = vm.education[0].Choices;
                            vm.minage = vm.education[0].Min;
                            vm.maxage = vm.education[0].Max;

                        }
                        endReq();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            pageLoad: function () {
                var vm = this;
                startReq();

                axios.post('/api/AdmissionApi/pageLoad')
                    .then(function (pl) {
                        vm.nationalities = pl.data["nat"];
                        vm.cities = pl.data["cit"];
                        vm.religions = pl.data["rel"];
                        //vm.programs = pl.data["pro"];
                        vm.degrees = pl.data["deg"];
                        vm.reasons = pl.data["rea"];
                        vm.categories = pl.data["cat"];

                        vm.choices = pl.data["cho"];
                        vm.genders = pl.data["gen"];
                        vm.amount = pl.data["amo"];
                        vm.domiciles = pl.data["dom"];
                        vm.st.Name = pl.data["name"];
                        vm.st.Email = pl.data["email"];

                        axios.post('/api/AdmissionApi/checkUpdate')
                            .then(function (up) {
                                if (up.data == "no") {
                                    endReq();
                                    $('#myModal').modal({
                                        backdrop: 'static',
                                        keyboard: false
                                    });
                                    vm.isupdate = false;

                                }
                                else {
                                    vm.st = up.data["ps"];
                                    vm.challan = up.data.ch;
                                    axios.post('/api/AdmissionApi/degreeChange?ID=' + vm.st.DegreeID)
                                        .then(function (de) {

                                            vm.programs = de.data["pro"];
                                            vm.alleducations = de.data["alledu"];

                                            if (up.data["pse"].length > 0) {
                                                vm.education = up.data["pse"];
                                                vm.education.filter((x) => { return x.EducationLevelID > 11 && x.TestDate != null })
                                                    .forEach(function (item) {
                                                        item.TestDate = convartDate(item.TestDate);
                                                    });
                                            }
                                            else {
                                                vm.education = de.data["edu"];
                                            }
                                            vm.allowedchoices = vm.education[0].Choices;
                                            vm.minage = vm.education[0].Min;
                                            vm.maxage = vm.education[0].Max;

                                            vm.choices = up.data["psc"];
                                            vm.alt = up.data["custom"];
                                            vm.isconfirmed = true;
                                            vm.isupdate = true;
                                            if (vm.st.temp != "") {
                                                vm.image = vm.st.temp;
                                            }
                                            endReq();

                                        })
                                        .catch(function (error) {
                                            console.log(error);
                                        })
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                            })
                    })
            },

            addProgram() {
                this.choices.push({ ProgramID: 0, CategoryID: 0, Type: 'Regular', Eligible: true, ReasonID: 0 });
            },

            programChange(progID, ind) {
                var cat = this.choices[ind].CategoryID;

                if (progID == 0 || cat == 0)
                    return;

                var countRegionalCategory = 0;
                var regionalCategoryID = 0;
                for (var i = 0; i < this.choices.length; i++) {

                    if (this.choices[i].CategoryID) {
                        var catID = this.choices[i].CategoryID;
                        var category = this.categories.find(x => x.AdmissionCategoryID == catID);

                        if (category && category.Type == "Regional" && regionalCategoryID == 0) {
                            countRegionalCategory++;
                            regionalCategoryID = category.AdmissionCategoryID;
                        }
                        else if (category && category.Type == "Regional" && regionalCategoryID != category.AdmissionCategoryID) {
                            toastr.info("Only 1 regional category selection is allowed per application", "Info!");
                            this.choices[ind].CategoryID = 0;
                            return
                        }

                        if (countRegionalCategory > 1) {
                            toastr.info("Only 1 regional category selection is allowed per application", "Info!");
                            this.choices[ind].CategoryID = 0;
                            return
                        }
                    }

                    if (i !== ind) {
                        if (this.choices[i].ProgramID === progID && this.choices[i].CategoryID == cat) {
                            toastr.error("Already Selected", "Error!");
                            this.choices[ind].ProgramID = 0;
                            this.choices[ind].CategoryID = 0;
                            return;
                        }
                    }
                }

                console.log("count " + countRegionalCategory);
            },

            removeProgram(ind) {
                this.choices.splice(ind, 1);
            },

            datanew() {

            },

            getFee(ind) {
                return (ind == 0 ? this.amount.FirstAdmissionFee : this.amount.SecondAdmissionFee);
            },

            validateAge() {
                var today = new Date();
                var birthDate = new Date(this.st.DateOfBirth);
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                if (age > this.maxage || age < this.minage) {
                    toastr.error("Age limit is " + this.minage + "-" + this.maxage);
                    this.st.DateOfBirth = "";
                }
            },

            validateFormNo: function () {
                startReq();
                if (this.st.FormNo != "") {
                    var vm = this;
                    axios.post('/api/AdmissionApi/validateFormNo', {
                        no: vm.st.FormNo,
                        cnic: vm.cnic
                    })
                        .then(function (response) {
                            endReq();

                            var result = response.data.replace('{"d":null}', '');
                            var er = JSON.parse(result);
                            console.log(er);

                            if (er['verified']) {
                                vm.showverified = true;
                                vm.showunverified = false;
                            }
                            else {
                                vm.showverified = false;
                                vm.showunverified = true;
                            }
                        })
                        .catch(function (error) {

                        });
                }
                endReq();
            },

            btnContinue() {
                $('#myModal').modal('hide');
                this.isconfirmed = true;
            },

            checkFile(file) {
                if (file == null) {
                    return false;
                }

                if (file.size > 70000) {
                    toastr.error("file size is large max size is 70 kb", "Error!");
                    return false;
                }

                if (file.type != "image/jpeg" && file.type != "image/png") {
                    toastr.error("invalid file");
                    return false;
                }

                return true;
            },

            onfileupload: function (event) {
                if (this.checkFile(event.target.files[0])) {
                    startReq();
                    var image = new Image;
                    var reader = new FileReader;
                    reader.onload = (e) => {
                        this.image = e.target.result;
                    }
                    reader.readAsDataURL(event.target.files[0]);
                    endReq();
                }
            },

            save: function (e) {
                e.preventDefault();
                var vm = this;

                vm.ischeck = false;

                if (this.st.IsOnline == 'false' && this.showverified == false && this.st.ProspectStudentID == 0) {
                    toastr.error("Form # and CNIC is not verified", "Error!");
                    return;
                }

                if (this.activetab == 1 && (this.st.CityID == 0 || this.st.CityID == '')) {
                    this.st.GenderID = 0;

                    this.st.FathersName = '';
                    this.st.FatherCNIC = '';
                    this.st.FatherMobileNo = '';
                    this.st.CityID = 0;
                    this.st.CountryID = 1;
                    this.st.Hafiz = 'false';
                    this.st.NationalityID = 1;
                    this.st.ReligionID = 0;
                    this.st.LandLineNo = '';
                    this.st.Address = '';
                    this.st.PostalAddress = '';
                    this.st.PostalCode = '';

                    this.st.DomicileID = 0;
                    this.st.BloodGroup = '';
                    this.st.Remarks = '';
                }

                //if (this.activetab == 1) {
                //  this.validateAge();
                //}

                if (this.activetab == 2 && (this.st.ReligionID == "" || this.st.ReligionID == null))
                    this.st.ReligionID = 0;

                if (this.st.CityID != 281)
                    this.st.OtherCity = "";

                startReq();
                axios.post('/api/AdmissionApi/SaveUOK', {
                    obj: vm.st,
                    education: vm.activetab == 3 ? vm.education : null,
                    choices: vm.choices,
                    documents: null,
                    img: vm.image,
                    tab: vm.activetab,
                })
                    .then(function (res) {

                        var er = res.data;
                        console.log(er);
                        if (er.ProspectStudentID != null) {
                            vm.st = er;
                            vm.activetab = vm.activetab + 1;
                            endReq();
                            vm.image = vm.st.temp;
                            toastr.success("Saved Successfully", "Done!");

                            if (vm.activetab > 5) {
                                setTimeout(function () {
                                    close();
                                }, 800);
                            }

                            return true;
                        }
                        endReq();
                        for (var i = 0; i < er.length; i++) {
                            toastr.error(er[i], "Error!");
                        }
                        return false;

                    })
                    .catch(function (error) {
                        console.log(error);
                        endReq();
                    })
            },

            update() {
                var vm = this;

                startReq();
                axios.post('/api/AdmissionApi/Update', {
                    obj: vm.st,
                    education: vm.education,
                    choices: vm.choices,
                    img: vm.image
                })
                    .then(function (res) {
                        var er = res.data;
                        endReq();
                        if (er == "success") {
                            toastr.success("Update Successfully", "Done!");
                            return;
                        }
                        for (var i = 0; i < er.length; i++) {
                            toastr.error(er[i], "Error!");
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        endReq();
                    })
            },

            marksChange(item) {
                if (item.ObtainedMarks != '' && item.TotalMarks != '') {

                    if (item.Type == 'Semester' && item.TotalMarks > 5) {
                        toastr.error("Total CGPA cannot be greated then 5");
                        item.ObtainedMarks = '';
                        item.TotalMarks = '';
                        item.Percentage = '0';
                        return;
                    }

                    if (Number(item.ObtainedMarks) > Number(item.TotalMarks)) {

                        toastr["error"]("Obtained marks cannot be greater then total marks")

                        item.ObtainedMarks = '';
                        item.TotalMarks = '';
                        item.Percentage = '0';
                        return;
                    }

                    //if (item.ObtainedMarks != '' && item.TotalMarks != '' && item.EducationLevelID == 2 && !item.ResultAwaiting) { 
                    //    if (item.Percentage < 45) {
                    //        toastr["error"]("Third division is not allowed");
                    //        item.ObtainedMarks = '';
                    //        item.TotalMarks = '';
                    //        item.Percentage = '0';
                    //        return;
                    //    }
                    //}

                    if (item.ObtainedMarks != '' && item.TotalMarks != '' && !item.ResultAwaiting) {

                        item.Percentage = (Number(item.ObtainedMarks) * 100) / Number(item.TotalMarks);

                        //For BS(hons)
                        if (this.st.DegreeID == 3) {
                            if (item.EducationLevelID == 2 && item.Percentage < 45) {
                                toastr["error"]("Third division is not allowed");
                                item.ObtainedMarks = '';
                                item.TotalMarks = '';
                                item.Percentage = '0';
                                return;
                            }
                        }

                        //For Master

                        else if (this.st.DegreeID == 4) {
                            if (item.EducationLevelID > 2 && item.EducationLevelID < 11 && item.Percentage < 45) {
                                toastr["error"]("Third division is not allowed");
                                item.ObtainedMarks = '';
                                item.TotalMarks = '';
                                item.Percentage = '0';
                                return;
                            }
                        }

                        //For Mphil/MS
                            
                        else if (this.st.DegreeID == 5 || this.st.DegreeID == 6) {
                            if (item.Percentage < 45) {
                                toastr["error"]("Third division is not allowed");
                                item.ObtainedMarks = '';
                                item.TotalMarks = '';
                                item.Percentage = '0';
                                return;
                            }
                        } 
                    }  
                }
            },
             
            moveUp(ind) {
                var origin = this.choices[ind];
                this.choices.splice(ind, 1, this.choices[ind - 1]);
                Vue.set(this.choices, ind - 1, origin);
            },

            moveDown(ind) {
                var origin = this.choices[ind];
                this.choices.splice(ind, 1, this.choices[ind + 1]);
                Vue.set(this.choices, ind + 1, origin);
            },

            getImgReq() {
                return (this.image == '../Images/icon-profile.png' ? true : false);
            },

            next() {
                this.save();
            },

            getStyle(t) {
                if (t < this.activetab) {
                    return 'color: #5cb85c; font-weight: bold;';
                }
            },

            back() {
                this.activetab = this.activetab - 1;
            },

            backToRecord() {
                if (!close()) {
                    window.location.href = "/Admission/ProspectStudents";
                }
            },

            removeEducation(ind) {
                this.education.splice(ind, 1);
            },

            resultAwaitingChange(i) {
                var ed = this.education[i];
                if (ed.ResultAwaiting == true) {
                    ed.TotalMarks = '0';
                    ed.ObtainedMarks = '0';
                    ed.Division = '';
                }
            },

            passingYearChange(i) {
                var d = new Date();
                if (this.education[i].PassingYear > d.getFullYear()) {
                    toastr.error("Passing year cannot be greater then current year", "Error!");
                    this.education[i].PassingYear = "";
                }
            },

            removePic() {
                this.image = '../Images/icon-profile.png';
                $('#fileUpload').val('');
            },

            disabilityChange() {
                if (!this.st.Disability) {
                    this.st.DisabilityType = null;
                }
            }
        }
    })

    function convartDate(jsonDate) {
        var shortDate = null;
        if (jsonDate) {
            var regex = /-?\d+/;
            var matches = regex.exec(jsonDate);
            var dt = new Date(parseInt(matches[0]));
            var month = dt.getMonth() + 1;
            var monthString = month > 9 ? month : '0' + month;
            var day = dt.getDate();
            var dayString = day > 9 ? day : '0' + day;
            var year = dt.getFullYear();
            shortDate = year + "-" + monthString + '-' + dayString;
        }
        return shortDate;
    };

    $(document).ready(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });</script>

<style scoped>
    .nav-tabs.flex-column .nav-item.show .nav-link, .nav-tabs.flex-column .nav-link.active {
        border-left: 3px solid #17a2b8;
    }

    .nav-item active {
        background-color: #17a2b8
    }

    .list-group-item {
        padding: 2px 0px;
    }

    .profile-username {
        font-size: 20px;
        margin-top: 5px;
    }

    .nav-link {
        font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/admissionForm.vue